<mat-card class="cardWithShadow">
  <mat-card-content>
    <div style="text-align: center" *ngIf="dataSource.data.length == 0">
      <h3>Sin Operaciones</h3>
    </div>

    <div
      *ngIf="existenDatos == true"
      class="table-responsive"
      [ngClass]="{ oculto: dataSource.data.length == 0 }"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        class="w-100"
        matSort
        matSortDirection="asc"
      >
        <!-- Name Column -->
        <ng-container matColumnDef="folio">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Folio
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="mat-body-1"
            style="text-decoration: underline; color: blue; cursor: pointer"
          >
            <h6>{{ element.folio }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="financedAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Monto Financiamiento
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{ element.financedAmount | currency : "CLP" : "symbol" }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="downPaymentPercentage">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            % Pago Inicial
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.downPaymentPercentage + "%" }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="fechaCesion">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Fecha Cesión
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{
                element.fechaCesion
                  ? (element.fechaCesion | date : "dd/MM/yyyy")
                  : "-"
              }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="operationState">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Estado de Operacion
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.operationState }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="transferAmount">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Monto Transferencia
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.transferAmount | currency : "CLP" : "symbol" }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="idMinute">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Minuta Id
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="mat-body-1"
            (click)="redirectMinute(element.idMinute)"
            style="color: blue; cursor: pointer; font-weight: bold"
          >
            <h6>{{ element.idMinute }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="comments">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Comentario
          </th>

          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <p class="text-overflow link-dialog" style="cursor: pointer">
              {{ element.comments }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="plazo">
          <th mat-header-cell *matHeaderCellDef class="th-title">Plazo</th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.plazo }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Creado
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.createdAt | date : "dd-MM-yyyy" }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="executiveName">
          <th mat-header-cell *matHeaderCellDef class="th-title">Ejecutivo</th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6 *ngIf="element?.executiveName == ' '">Sin Asignar</h6>
            <h6 *ngIf="element?.executiveName != ' '">
              {{ element.executiveName }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef class="th-title">Tasa</th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.rate }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="allInRate">
          <th mat-header-cell *matHeaderCellDef class="th-title">Tasa Total</th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.allInRate }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUpdate">
          <th mat-header-cell *matHeaderCellDef class="th-title">
            Último cambio
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{
                element.lastUpdate
                  ? (element.lastUpdate | date : "dd-MM-yyyy")
                  : "-"
              }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="dateAcept">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Fecha Aceptacion
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <p>{{ element.dateAcept }}</p>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
